module.exports = __webpack_public_path__ + "static/media/rewards.e8586485.png";